import React, {Component} from "react";
import Paper from 'material-ui/Paper';
import { Grid, Row, Col } from 'react-flexbox-grid';

import ChapterSummary from '../components/ChapterSummary/ChapterSummary';

import "../App.css";


class Contents extends Component {
    render() {
        return (
            <div className="content">
                <Grid fluid style={{padding: 0}}>
                    <Row>
                        <ChapterSummary title="Chapter 1" subtitle="Diving in" subsubtitle="getting started" img="./chap01img.png">
                            <h2>Android has taken the world by storm</h2>

                            Everybody wants a smartphone or tablet, and Android devices are hugely popular. In this
                            book, we’ll teach you how to <strong>develop your own apps</strong>, and we’ll start by
                            getting you to build a basic app and run it on an Android Virtual Device. Along the way, you’ll meet
                            some of the basic components of all Android apps, such as <strong>activities</strong> and
                            <strong>layouts</strong>. All you need is a little Java know-how...
                        </ChapterSummary>

                        <ChapterSummary title="Chapter 2" subtitle="Apps that do something" subsubtitle="building interactive apps" img="chap02img.png">
                            <h2>Most apps need to respond to the user in some way</h2>

                            In this chapter, you’ll see how you can make your apps a bit more interactive. You’ll learn
                            how to get your app to do something in response to the user, and how to get your activity
                            and layout talking to each other like best buddies. Along the way, we’ll take you a bit
                            deeper into how Android actually works by introducing you to R, the hidden gem that glues
                            everything together.
                        </ChapterSummary>

                        <ChapterSummary title="Chapter 3" subtitle="State your intent" subsubtitle="multiple activities and intents" img="chap03img.png">
                            <h2>Most apps need more than one activity</h2>

                            So far we’ve just looked at single-activity apps, which is fine for simple apps. But when
                            things get more complicated, just having the one activity won’t cut it. We’re going to
                            show you how to build apps with multiple activities, and how you can get your apps
                            talking to each other using intents. We’ll also look at how you can use intents to go
                            beyond the boundaries of your app and make activities in other apps on your device
                            perform actions. Things just got a whole lot more powerful...
                        </ChapterSummary>

                        <ChapterSummary title="Chapter 4" subtitle="Being an Activity" subsubtitle="the activity lifecycle" img="chap04img.png">
                            <h2>Activities form the foundation of every Android app</h2>

                            So far you’ve seen how to create activities, and made one activity start another using an
                            intent. But what’s really going on beneath the hood? In this chapter, we’re going to dig
                            a little deeper into the activity lifecycle. What happens when an activity is created
                            and destroyed? Which methods get called when an activity is made visible and appears in
                            the foreground, and which get called when the activity loses the focus and is hidden? And
                            how do you save and restore your activity’s state?
                        </ChapterSummary>

                        <ChapterSummary title="Chapter 5" subtitle="Enjoy the View" subsubtitle="views and view groups" img="chap05img.png">
                            <h2>You’ve seen how to arrange GUI components using a linear layout, but so far
                                we’ve only scratched the surface.</h2>

                            In this chapter we’ll look a little deeper and show you how linear layouts really work.
                            We’ll introduce you to the frame layout, a simple layout used to stack views, and we’ll
                            also take a tour of the main GUI components and how you use them. By the end of the
                            chapter, you’ll see that even though they all look a little different, all layouts and
                            GUI components have more in common than you might think.
                        </ChapterSummary>

                        <ChapterSummary title="Chapter 6" subtitle="Put Things in their Place" subsubtitle="constraint layouts" img="chap06img.png">
                            <h2>Let’s face it, you need to know how to create great layouts.</h2>

                            If you’re building apps you want people to use, you need to make sure they look exactly
                            the way you want. So far you’ve seen how to use linear and frame layouts, but what
                            if your design is more complex? To deal with this, we’ll introduce you to Android’s new
                            constraint layout, a type of layout you build visually using a blueprint. We’ll show you
                            how constraints let you position and size your views, irrespective of screen size and
                            orientation. Finally, you’ll find out how to save time by making Android Studio infer
                            and add constraints on your behalf.
                        </ChapterSummary>

                        <ChapterSummary title="Chapter 7" subtitle="Getting Organized" subsubtitle="list views and adapters" img="chap07img.png">
                            <h2>Want to know how best to structure your Android app </h2>

                            You’ve learned about some of the basic building blocks that are used to create apps,
                            and now it’s time to get organized. In this chapter, we’ll show you how you can take a
                            bunch of ideas and structure them into an awesome app. You'll learn how lists of data can
                            form the core part of your app design, and how linking them together can create a powerful
                            and easy-to-use app. Along the way, you’ll get your first glimpse of using event
                            listeners and adapters to make your app more dynamic.
                        </ChapterSummary>

                        <ChapterSummary title="Chapter 8" subtitle="Taking Shortcuts" subsubtitle="support libraries and app bars" img="chap08img.png">
                            <h2>Everybody likes a shortcut</h2>

                            And in this chapter you’ll see how to add shortcuts to your apps using app bars. We’ll
                            show you how to start activities by adding actions to your app bar, how to share content
                            with other apps using the share action provider, and how to navigate up your app’s
                            hierarchy by implementing the app bar’s Up button. Along the way we'll introduce you to
                            the powerful Android Support Libraries, which are key to making your apps look fresh on
                            older versions of Android.
                        </ChapterSummary>

                        <ChapterSummary title="Chapter 9" subtitle="Make it Modular" subsubtitle="fragments" img="chap09img.png">
                            <h2>You’ve seen how to create apps that work in the same way no matter what device they’re running on</h2>

                            But what if you want your app to look and behave differently depending on whether
                            it’s running on a phone or a tablet? In this case you need fragments, modular code
                            components that can be reused by different activities. We’ll show you how to create basic
                            fragments and list fragments, how to add them to your activities, and how to get your
                            fragments and activities to communicate with one another.
                        </ChapterSummary>

                        <ChapterSummary title="Chapter 10" subtitle="Different Size, Different Interface" subsubtitle="fragments for larger interfaces" img="chap10img.png">
                            <h2>So far we've only run our apps on devices with a small screen</h2>

                            But what if your users have tablets? In this chapter you'll see how to create flexible
                            user interfaces by making your app look and behave differently depending on the device
                            it's running on. You'll discover how to control the behavior of your app when you press
                            the back button by introducing you to the back stack and fragment transactions. Finally,
                            you'll find out how to save and restore the state of your fragment.
                        </ChapterSummary>

                        <ChapterSummary title="Chapter 11" subtitle="Nesting Fragments" subsubtitle="dynamic fragments" img="chap11img.png">
                            <h2>So far you’ve seen how to create and use static fragments</h2>

                            But what if you want your fragments to be more dynamic? Dynamic fragments have a lot in
                            common with dynamic activities, but there are crucial differences you need to be able to
                            deal with. In this chapter you’ll see how to convert dynamic activities into working
                            dynamic fragments. You’ll find out how to use fragment transactions to help maintain
                            your fragment state. Finally, you’ll discover how to nest one fragment inside another,
                            and how the child fragment manager helps you control unruly back stack behavior.
                        </ChapterSummary>

                        <ChapterSummary title="Chapter 12" subtitle="Swipe Right" subsubtitle="design support library" img="chap12img.png">
                            <h2>Ever wondered how to develop apps with a rich, slick UI </h2>

                            With the release of the Android Design Support Library, it became much easier
                            to create apps with an intuitive UI. In this chapter, we’ll show you round some of the
                            highlights. You’ll see how to add tabs so that your users can navigate around your
                            app more easily. You’ll discover you how to animate your toolbars so that they can
                            collapse or scroll on a whim. You’ll find out how to add Floating Actions Buttons for
                            common user actions. Finally, we’ll introduce you to Snackbars, a way of displaying
                            short, informative messages to the user which they can interact with.
                        </ChapterSummary>

                        <ChapterSummary title="Chapter 13" subtitle="Get Recycling" subsubtitle="recycler views and card views" img="chap13img.png">
                            <h2>You’ve already seen how the humble list view is a key part of most apps</h2>

                            But compared to some of the material design components we’ve seen, it’s somewhat plain.
                            In this chapter, we’ll introduce you to the recycler view, a more advanced type of list
                            that gives you loads more flexibility and fits in with the material design ethos. You’ll
                            see how to create adapters tailored to your data, and how to completely change the look
                            of your list with just two lines of code. We’ll also show you howto use card views to
                            give your data a 3D material design appearance.
                        </ChapterSummary>

                        <ChapterSummary title="Chapter 14" subtitle="Going Places" subsubtitle="navigation drawers" img="chap14img.png">
                            <h2>You’ve already seen how tabs help users navigate your apps</h2>

                            But if you need a large number of them, or want to split them into sections, the
                            navigation drawer is your new BFF. In this chapter, we’ll show you how to create a
                            navigation drawer which slides out from the side of your activity at a single touch.
                            You’ll learn how to give it a header using a navigation view, and provide it with a
                            structured set of menu items to take the user to all the major hubs of your app.
                            Finally, you’ll discover how to set up a navigation view listener so that the drawer
                            responds to the slightest touch and swipe.
                        </ChapterSummary>

                        <ChapterSummary title="Chapter 15" subtitle="Fire Up the Database" subsubtitle="SQLite databases" img="chap15img.png">
                            <h2>If you’re recording high scores or saving tweets, your app will need to store data</h2>

                            And on Android you usually keep your data safe inside a SQLite database. In this chapter,
                            we’ll show you how to create a database, add tables to it, and prepopulate it with data,
                            all with the help of the friendly SQLite helper. You’ll then see how you can cleanly roll
                            out upgrades to your database structure, and how to downgrade it if you need to undo
                            any changes.
                        </ChapterSummary>

                        <ChapterSummary title="Chapter 16" subtitle="Getting Data Out" subsubtitle="basic cursors" img="chap16img.png">
                            <h2>So how do you connect your app to a SQLite database?</h2>

                            So far you’ve seen how to create a SQLite database using a SQLite helper. The next step
                            is to get your activities to access it. In this chapter, we’ll focus on how you read
                            data from a database. You’ll find out how to use cursors to get data from the database.
                            You’ll see how to navigate cursors, and how to get access to their data. Finally,
                            you'll discover how to use cursor adapters to bind cursors to list views.
                        </ChapterSummary>

                        <ChapterSummary title="Chapter 17" subtitle="Staying in the Background" subsubtitle="cursors and asynctasks" img="chap17img.png">
                            <h2>In most apps, you’ll need your app to update its data</h2>

                            So far you’ve seen how to create apps that read data from a SQLite database. But what if
                            you want to update the app’s data? In this chapter you’ll see how to get your app to
                            respond to user input and update values in the database. You’ll also find out how to
                            refresh the data that’s displayed once its been updated. Finally, you’ll see how writing
                            efficient multithreaded code with AsyncTasks will keep your app speedy.
                        </ChapterSummary>

                        <ChapterSummary title="Chapter 18" subtitle="At Your Service" subsubtitle="started services" img="chap18img.png">
                            <h2>There are some operations you want to keep on running, irrespective of which app has the focus</h2>

                            If you start downloading a file, for instance, you don’t want the download to stop when
                            you switch to another app. In this chapter we’ll introduce you to started services,
                            components which run operations in the background. You’ll see how to create a started
                            service using the IntentService class, and find out how its lifecycle fits in with that
                            of an activity. Along the way, you’ll discover how to log messages, and keep users
                            informed using Android’s built-in notification service.
                        </ChapterSummary>

                        <ChapterSummary title="Chapter 19" subtitle="Bound Together" subsubtitle="bound services and permissions" img="chap19img.png">
                            <h2>Started services are great for background operations, but what if you need a service that’s more interactive?</h2>

                            In this chapter you’ll discover how to create a bound service, a type of service your
                            activity can interact with. You’ll see how to bind to the service when you need it, and
                            how to unbind from it when you’re done to save resources. You’ll find out how to use
                            Android’s Location Services to get location updates from your device GPS. Finally,
                            you’ll discover how to use Android’s permission model, including handling runtime
                            permission requests.
                        </ChapterSummary>
                    </Row>
                </Grid>
            </div>
        );
    }
}

export default Contents;



// WEBPACK FOOTER //
// ./src/containers/Contents.js